import { v1 as uuidv1 } from 'uuid';
export function generateUUID() {
  return uuidv1();
}
